import type { UserListItem } from "../../types/plan.types";
import type { WorkspaceProfileTableRow } from "../../types/workspace-profile.types";

function displayOrDash(value: string | null | undefined): string {
  const v = (value ?? "").trim();
  if (!v || v === "N/A") {
    return "—";
  }
  return v;
}

/**
 * Maps admin user list API item to workspace profile table row.
 */
export function mapUserListItemToWorkspaceProfileRow(
  user: UserListItem
): WorkspaceProfileTableRow {
  const fromParts = [user.first_name, user.last_name]
    .filter((p): p is string => typeof p === "string" && p.trim().length > 0)
    .join(" ")
    .trim();
  const fullName =
    fromParts || (user.name && user.name !== "N/A" ? user.name.trim() : "") || "—";

  return {
    id: user.id,
    fullName,
    email: displayOrDash(user.email),
    company: displayOrDash(user.company),
    jobTitle: displayOrDash(user.job_title),
    phone: displayOrDash(user.phone_number),
  };
}
